<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
// Template SFC — PRESENTATION ONLY (DEV-1135 template purity contract).
defineProps<{
  quiz: {
    logo?: string;
    title?: string;
    sub_title?: string;
    legal_name?: string;
    legal_id?: string;
    disclaimer?: string;
    privacy_url?: string;
    privacy_text?: string;
  };
  progress: { current: number; total: number };
  canGoBack: boolean;
  showHero: boolean;
  isGate: boolean;
}>();
</script>

<template>
  <div class="tpl-wit">
    <main class="tpl-wit__main">
      <header class="tpl-wit__header">
        <img v-if="quiz.logo" :src="quiz.logo" alt="logo" class="tpl-wit__logo" />
      </header>

      <div v-if="showHero" class="tpl-wit__hero">
        <h1 class="tpl-wit__hero-title">{{ quiz.title }}</h1>
        <p v-if="quiz.sub_title" class="tpl-wit__hero-sub">{{ quiz.sub_title }}</p>
      </div>

      <div class="tpl-wit__progress-track">
        <div
          class="tpl-wit__progress-fill"
          :style="{
            width: (isGate ? 100 : (progress.current / Math.max(progress.total + 1, 1)) * 100) + '%',
          }"
        ></div>
      </div>

      <slot />

      <footer class="tpl-wit__footer">
        <p v-if="quiz.privacy_url">
          <a :href="quiz.privacy_url" target="_blank">{{ quiz.privacy_text || 'Privacy Policy' }}</a>
        </p>
        <p v-if="quiz.legal_name" class="tpl-wit__footer-legal">
          {{ quiz.legal_name }}<template v-if="quiz.legal_id"> — {{ quiz.legal_id }}</template>
        </p>
        <p v-if="quiz.disclaimer" class="tpl-wit__footer-disclaimer">{{ quiz.disclaimer }}</p>
      </footer>
    </main>
  </div>
</template>
